"use client";

import { saveVisitorStat } from "@/server-actions/get-device-info";
import { usePathname } from "next/navigation";
import React, { useEffect } from "react";

const DetectUser = ({ article }: { article?: string }) => {
  const path = usePathname();

  useEffect(() => {
    if (typeof window === "undefined" || !path) return;

    const key = `visitorStatSaved:${path}`;
    const alreadySent = sessionStorage.getItem(key);
    if (alreadySent) return;

    sessionStorage.setItem(key, "true"); // Set this immediately to prevent duplicate triggers

    const sendStat = async () => {
      try {
        const res = await fetch("https://ipwho.is/");
        const data = await res.json();
        await saveVisitorStat(data, path, article);
      } catch (error) {
        console.error("Failed to save visitor stat:", error);
      }
    };

    sendStat();
  }, [path, article]);

  return null;
};

export default DetectUser;
